import "@hotwired/turbo-rails"
import "@tabler/core"
import './login.scss'
import { Turbo } from "@hotwired/turbo-rails"
window.Turbo = Turbo

import { Application, Controller} from "@hotwired/stimulus"
import { registerControllers } from 'stimulus-vite-helpers'

const application = Application.start()

window.application = application
//@ts-ignore
const controllers = import.meta.glob('./../controllers/orsy_xp_controller.ts', {eager: true})
registerControllers(application, controllers)